/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
import React from 'react';
import style from './memoChip.module.scss';
import cx from 'classnames';
import { Tag } from 'store/types';
import Close from 'icons/close';

export type ChipClickHandler = (tag: Tag, e: React.MouseEvent) => void;

type ChipProps = {
  tag: Tag;
  onClick: ChipClickHandler;
  onIconClick?: ChipClickHandler;
  endIcon?: React.ReactElement | '';
  isAmountEnabled?: boolean;
  className?: string;
  isFocused?: boolean;
  ref?: React.RefObject<HTMLDivElement>;
};

const ChipForward = React.forwardRef<HTMLDivElement, ChipProps>(
  (
    {
      tag,
      onClick,
      onIconClick,
      endIcon,
      isAmountEnabled,
      className,
      isFocused = false,
    },
    ref
  ) => {
    return (
      <div
        className={cx(
          style.container,
          tag.isNew ? style.isNew : '',
          className,
          isAmountEnabled ? style.isAmount : '',
          isFocused ? style.isFocused : '',
          'adaptive-memoChip__container'
        )}
        onClick={onClick.bind(null, tag)}
        ref={ref}
      >
        {tag.name}
        {isAmountEnabled && (
          <span className={cx(style.amount, 'adaptive-memoChip__amount')}>
            &nbsp;{tag.amount}&nbsp;
          </span>
        )}
        {(onIconClick || endIcon) && (
          <div
            className={cx(style.icon, 'chipEndIcon')}
            onClick={onIconClick?.bind(null, tag)}
          >
            {endIcon || <Close strokeColor={tag.isNew ? 'white' : 'black'} />}
          </div>
        )}
      </div>
    );
  }
);

// Передача вторым параметром неправильного компаратора вызывает крайне тяжело отлавливаемые баги!
const ChipMemoComponent = React.memo(ChipForward);
ChipMemoComponent.displayName = 'ChipMemoComponent';

export default ChipMemoComponent;
